var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.333,0 L6.667,0 C2.985,0 0,2.985 0,6.667 L0,25.333 C0,29.015 2.985,32 6.667,32 L25.333,32 C29.016,32 32,29.015 32,25.333 L32,6.667 C32,2.985 29.016,0 25.333,0 Z M21.333,9.333 L18.768,9.333 C17.948,9.333 17.333,9.669 17.333,10.519 L17.333,12 L21.333,12 L21.016,16 L17.333,16 L17.333,26.667 L13.333,26.667 L13.333,16 L10.667,16 L10.667,12 L13.333,12 L13.333,9.436 C13.333,6.74 14.752,5.333 17.948,5.333 L21.333,5.333 L21.333,9.333 Z"}));
}

Facebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Facebook;

Facebook.default = Facebook;
